"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitesTab = void 0;
const router_1 = require("client/components/router");
const store_1 = require("client/modules/sites/modules/sites-list/store");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_sites_1 = require("../../components/edit-sites");
const store_2 = require("../../store");
let SitesTab = class SitesTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleCancel = () => {
            router_1.RouteManager.transitionTo("/formulary");
        };
        this.handleSave = (inventory, inventorySites) => {
            console.info("inventory", inventory);
            console.info("inventorySites", inventorySites);
            store_2.inventoryDetailStore.saveInventorySites(inventory, inventorySites);
        };
        this.handleUpdateSite = (inventory, inventorySite) => {
            store_2.inventoryDetailStore.updateInventorySite(inventory, inventorySite);
        };
        // Active Formulary > Does not save update after select all then deselect all C-046.182
        this.handleUpdateAllSite = (inventory, siteIds, checkedSelection, isCheckedAll) => {
            if (siteIds && siteIds.length > 0) {
                store_2.inventoryDetailStore.updateInventoryAllSite(inventory, siteIds, checkedSelection, isCheckedAll);
            }
            else {
                store_2.inventoryDetailStore.updateInventoryAllSite(inventory, undefined, checkedSelection, isCheckedAll);
            }
        };
        this.handleSearch = (value) => {
            store_2.inventoryDetailStore.loadICD10s(value);
        };
    }
    componentWillMount() {
        // sitesListStore.loadSites();
        store_2.inventoryDetailStore.shouldHideViewIndication = true;
        store_1.sitesListStore.loadSitesNoRelation();
        // console.log("inside sitestab, this.props.params is ", this.props.params);
    }
    componentWillUnmount() {
        store_2.inventoryDetailStore.shouldHideViewIndication = false;
    }
    render() {
        return (React.createElement("div", { className: "inventory-detail__form" },
            React.createElement(edit_sites_1.EditSites, { error: store_1.sitesListStore.sites.error, inventory: store_2.inventoryDetailStore.inventory.value, onCancel: this.handleCancel, onSave: this.handleSave, onUpdateSite: this.handleUpdateSite, updateAllsite: this.handleUpdateAllSite, onSearch: this.handleSearch, status: store_2.inventoryDetailStore.inventory.status })));
    }
};
SitesTab = __decorate([
    mobx_react_1.observer
], SitesTab);
exports.SitesTab = SitesTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/tabs/sites/sites.tsx
// module id = 3486
// module chunks = 0